import * as m from '$lib/paraglide/messages';
import type { WikiCategory } from './frontmatter';

const CATEGORY_LABELS: Record<WikiCategory, () => string> = {
	'getting-started': m.wiki_category_getting_started,
	concepts: m.wiki_category_concepts,
	features: m.wiki_category_features,
	integrations: m.wiki_category_integrations,
	faq: m.wiki_category_faq
};

/** Etykieta kategorii wiki w bieżącym locale; fallback na surowy slug. */
export function wikiCategoryLabel(category: WikiCategory): string {
	return CATEGORY_LABELS[category]?.() ?? category;
}
